// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    const scrollcontent = accordion.getAttribute("js-acc-single-trigger-scroll") || null;
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}
// accordions js end

(function() {
    faq_taggol();
})();

const faq_main_wap = document.querySelector("[faq_main_wap]") || null;
if (faq_main_wap) {
    const faq_toggles = faq_main_wap.querySelectorAll("[data-act-title]") || null
      , faq_content_wap = faq_main_wap.querySelector("[faq_content_wap]") || null
      , faq_content_tabs = faq_content_wap.querySelectorAll(".tabs") || null
      , faq_dropdown = faq_main_wap.querySelector(".faq-category-dropdown") || null
      , faq_selected = faq_main_wap.querySelector(".faq-category-selected") || null
      , mian_tag = document.querySelector(".faq-category") || null
      , content = document.querySelector("[js-acc-single-content]");
    faq_content_wap && (faq_toggles.forEach(faq => {
        faq.addEventListener("click", event => {
            faq_content_tabs.forEach(tab => {
                tab.classList.remove("active"),
                tab.style.display = "none"
            }
            ),
            faq_toggles.forEach(toggle => {
                toggle.classList.remove("active-tab")
            }
            );
            const targetSelector = event.currentTarget.getAttribute("data-act-title")
              , targetTab = faq_content_wap.querySelector(targetSelector);
            targetTab && (targetTab.classList.add("active"),
            targetTab.style.display = "block"),
            event.currentTarget.classList.add("active-tab"),
            faq_dropdown && faq_selected && (faq_selected.textContent = event.currentTarget.textContent.trim(),
            faq_dropdown.classList.remove("open"),
            mian_tag.classList.remove("active"),
            content && (content.style.maxHeight = null))
        }
        )
    }
    ),
    faq_dropdown && faq_dropdown.addEventListener("click", () => {
        faq_dropdown.classList.toggle("open")
    }
    ))
}


 //blog Dropdown change

  const sortingDropdown = document.getElementById("sorting-dropdown");

  if (sortingDropdown) {
    sortingDropdown.addEventListener("change", function () {
      const selectedOption = this.value;
      console.log(selectedOption, "selectedOption");

      // Run sort function
      sortBlogPosts(selectedOption);
    });
  }

  function sortBlogPosts(option) {
    const postsContainer = document.querySelector(".blog-articles");
    if (!postsContainer) return;

    const posts = Array.from(postsContainer.querySelectorAll(".cust_sort_blog"));
    if (!posts.length) return;

    // Helper: convert "DD.MM.YYYY" to valid JS Date
    function parseCustomDate(dateStr) {
      const parts = dateStr.trim().split(".");
      if (parts.length !== 3) return new Date(NaN);
      const [day, month, year] = parts.map(Number);
      return new Date(year, month - 1, day);
    }

    // Debug: show current titles and dates
    posts.forEach(post => {
      const titleEl = post.querySelector(".blog-post-title");
      const dateEl = post.querySelector(".blog-post-date");
      console.log("Post:", titleEl?.textContent.trim(), "| Date:", dateEl?.textContent.trim());
    });

    // Sort logic
    switch (option) {
      case "title-ascending":
        posts.sort((a, b) =>
          a.querySelector(".blog-post-title").textContent.trim()
            .localeCompare(b.querySelector(".blog-post-title").textContent.trim())
        );
        break;

      case "title-descending":
        posts.sort((a, b) =>
          b.querySelector(".blog-post-title").textContent.trim()
            .localeCompare(a.querySelector(".blog-post-title").textContent.trim())
        );
        break;

      case "created-ascending": // oldest first
        posts.sort((a, b) => {
          const dateA = parseCustomDate(a.querySelector(".blog-post-date").textContent);
          const dateB = parseCustomDate(b.querySelector(".blog-post-date").textContent);
          return dateA - dateB;
        });
        break;

      case "created-descending": // newest first
        posts.sort((a, b) => {
          const dateA = parseCustomDate(a.querySelector(".blog-post-date").textContent);
          const dateB = parseCustomDate(b.querySelector(".blog-post-date").textContent);
          return dateB - dateA;
        });
        break;

      default:
        // Manual (original) order — do nothing
        break;
    }

    // Clear old posts & re-append sorted ones
    postsContainer.innerHTML = "";
    posts.forEach(post => postsContainer.appendChild(post));
  }


// ACTIVE CLASS ADD IN MENU ITEM
// document.addEventListener("DOMContentLoaded", () => {
//   const menuLinks = document.querySelectorAll("header a[href]");

//   menuLinks.forEach(link => {
//     link.addEventListener("click", function () {
//       // Remove 'active' class from all links
//       menuLinks.forEach(l => l.classList.remove("active"));
//       // Add 'active' to the clicked link
//       this.classList.add("active");
//     });
//   });

//   // Optional: add active class based on current page URL
//   const currentUrl = window.location.pathname;
//   menuLinks.forEach(link => {
//     if (link.getAttribute("href") === currentUrl) {
//       link.classList.add("active");
//     }
//   });
// });



// document.addEventListener("DOMContentLoaded", function() {
//   const megaMenu = document.querySelector('#Details-HeaderMenu-4');
//   const body = document.body;

//   if (megaMenu) {
//     megaMenu.addEventListener('toggle', function() {
//       if (megaMenu.open) {
//         body.classList.add('mega-menu-open');
//       } else {
//         body.classList.remove('mega-menu-open');
//       }
//     });
//   }
// });


// document.querySelectorAll('summary a').forEach(link => {
//   link.addEventListener('click', e => e.stopPropagation());
// });

document.querySelectorAll('summary-custom').forEach((summary) => {
  summary.addEventListener('click', () => {
    const details = summary.closest('accordian-custom');
    const body = document.body;

    if (details) {
      if (details.hasAttribute('open')) {
        details.removeAttribute('open');
        body.classList.remove('mega-menu-open');
      } else {
        details.setAttribute('open', '');
        body.classList.add('mega-menu-open');
      }
    }
  });
});

// ✅ Add logic to open on body click
document.body.addEventListener('click', (event) => {
  // Skip if the click is inside an accordian or summary
  if (event.target.closest('accordian-custom') || event.target.closest('summary-custom')) {
    return;
  }

  // Find all accordian-custom elements and open them
  document.querySelectorAll('accordian-custom').forEach((details) => {
    details.removeAttribute('open', '');
  });

  document.body.classList.remove('mega-menu-open');
});
